import { render, staticRenderFns } from "./FormTax.vue?vue&type=template&id=40226748&"
import script from "./FormTax.vue?vue&type=script&lang=ts&"
export * from "./FormTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40226748')) {
      api.createRecord('40226748', component.options)
    } else {
      api.reload('40226748', component.options)
    }
    module.hot.accept("./FormTax.vue?vue&type=template&id=40226748&", function () {
      api.rerender('40226748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ArPrepayment/FormTax.vue"
export default component.exports